import { ManfrediteEmailUpdateOperationRequest } from './manfredite-email-update-operation.request';
export const createMockedManfrediteEmailUpdateOperationRequest = (customValues = {}) => {
    const request = new ManfrediteEmailUpdateOperationRequest();
    request.newEmail = customValues.newEmail ?? 'newmail@examle.com';
    request.requestHash = customValues.requestHash ?? '1a8b791f-c8d9-40b3-aabc-bbf6560a00da';
    return request;
};
//# sourceMappingURL=manfredite-email-update-operation.request.mock.js.map